<script>
import { mapGetters } from 'vuex';
import { useVuelidate } from '@vuelidate/core';
import { useAlert } from 'dashboard/composables';
import { required } from '@vuelidate/validators';
import router from '../../../../index';
import PageHeader from '../../SettingsSubPageHeader.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';

export default {
  components: {
    PageHeader,
    NextButton,
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      inboxName: '',
      allowedDomains: '',
      successMessage: '',
    };
  },
  computed: {
    ...mapGetters({
      uiFlags: 'inboxes/getUIFlags',
    }),
  },
  validations: {
    inboxName: { required },
  },
  methods: {
    async createChannel() {
      this.v$.$touch();
      if (this.v$.$invalid) {
        return;
      }

      try {
        const leadFormChannel = await this.$store.dispatch(
          'inboxes/createChannel',
          {
            name: this.inboxName,
            channel: {
              type: 'lead_form',
              allowed_domains: this.allowedDomains,
              success_message: this.successMessage,
            },
          }
        );
        router.replace({
          name: 'settings_inboxes_add_agents',
          params: {
            page: 'new',
            inbox_id: leadFormChannel.id,
          },
        });
      } catch (error) {
        useAlert(
          error.message ||
            this.$t('INBOX_MGMT.ADD.LEAD_FORM_CHANNEL.API.ERROR_MESSAGE')
        );
      }
    },
  },
};
</script>

<template>
  <div
    class="border border-n-weak bg-n-solid-1 rounded-t-lg border-b-0 h-full w-full p-6 col-span-6 overflow-auto"
  >
    <PageHeader
      :header-title="$t('INBOX_MGMT.ADD.LEAD_FORM_CHANNEL.TITLE')"
      :header-content="$t('INBOX_MGMT.ADD.LEAD_FORM_CHANNEL.DESC')"
    />
    <form class="flex flex-wrap mx-0" @submit.prevent="createChannel()">
      <div class="w-[65%] flex-shrink-0 flex-grow-0 max-w-[65%]">
        <label :class="{ error: v$.inboxName.$error }">
          {{ $t('INBOX_MGMT.ADD.LEAD_FORM_CHANNEL.NAME.LABEL') }}
          <input
            v-model="inboxName"
            type="text"
            :placeholder="
              $t('INBOX_MGMT.ADD.LEAD_FORM_CHANNEL.NAME.PLACEHOLDER')
            "
            @blur="v$.inboxName.$touch"
          />
          <span v-if="v$.inboxName.$error" class="message">
            {{ $t('INBOX_MGMT.ADD.LEAD_FORM_CHANNEL.NAME.ERROR') }}
          </span>
        </label>

        <label>
          {{ $t('INBOX_MGMT.ADD.LEAD_FORM_CHANNEL.DOMAINS.LABEL') }}
          <input
            v-model="allowedDomains"
            type="text"
            :placeholder="
              $t('INBOX_MGMT.ADD.LEAD_FORM_CHANNEL.DOMAINS.PLACEHOLDER')
            "
          />
        </label>
        <p class="text-sm text-n-slate-11">
          {{ $t('INBOX_MGMT.ADD.LEAD_FORM_CHANNEL.DOMAINS.SUBTITLE') }}
        </p>

        <label>
          {{ $t('INBOX_MGMT.ADD.LEAD_FORM_CHANNEL.SUCCESS.LABEL') }}
          <input
            v-model="successMessage"
            type="text"
            :placeholder="
              $t('INBOX_MGMT.ADD.LEAD_FORM_CHANNEL.SUCCESS.PLACEHOLDER')
            "
          />
        </label>
      </div>

      <div class="w-full mt-4">
        <NextButton
          :is-loading="uiFlags.isCreating"
          type="submit"
          solid
          blue
          :label="$t('INBOX_MGMT.ADD.LEAD_FORM_CHANNEL.SUBMIT_BUTTON')"
        />
      </div>
    </form>
  </div>
</template>
